import { useDevice } from '@contexts/device';
import Skeleton from '@components/skeletons/Skeleton';
import { FlexibleDiv } from '@components/formStyles';

import { Wrapper, TextContentWrapper } from './styled';

const PaymentOptionDetailSkeleton = () => {
  const { isDesktop } = useDevice();
  return (
    <FlexibleDiv top={40}>
      <Wrapper>
        <FlexibleDiv bottom={40}>
          <Skeleton height={isDesktop ? 500 : 200} borderRadius={8} />
        </FlexibleDiv>
        <TextContentWrapper>
          <FlexibleDiv bottom={20}>
            <Skeleton width={207} height={17} borderRadius={8} />
          </FlexibleDiv>

          <FlexibleDiv bottom={18}>
            <Skeleton
              width={isDesktop ? 120 : 250}
              height={isDesktop ? 51 : 70}
              borderRadius={8}
            />
          </FlexibleDiv>

          <FlexibleDiv bottom={40}>
            <Skeleton height={51} borderRadius={8} />
          </FlexibleDiv>
        </TextContentWrapper>
      </Wrapper>
    </FlexibleDiv>
  );
};

export default PaymentOptionDetailSkeleton;
